import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslocoModule } from "@ngneat/transloco";
import { AgVirtualScrollModule } from "ag-virtual-scroll";
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { MainTaskComponent } from "./main-task/main-task.component";
import { MainTasksComponent } from "./main-tasks/main-tasks.component";
import { SvcUserAvatarModule } from '@solvace/component/svc-user-avatar';
import { SvcStatusBadgeModule } from '@solvace/component/svc-status-badge';
import { SvcLockButtonModule } from '@solvace/component/svc-lock-button';
import { SvcProgressBarModule } from '@solvace/component/svc-progress-bar';
import { MainTaskSkeletonModule } from './main-task-skeleton/main-task-skeleton.module';
import { SvcBookmarkButtonModule } from '@solvace/feature/general/svc-bookmark-button';

@NgModule({
  declarations: [
    MainTaskComponent,
    MainTasksComponent
  ],
  imports: [
    CommonModule,
    LibSharedCommonModule,
    MatExpansionModule,
    AgVirtualScrollModule,
    SvcLockButtonModule,
    SvcBookmarkButtonModule,
    SvcUserAvatarModule,
    SvcStatusBadgeModule,
    SvcProgressBarModule,
    MatTooltipModule,
    TranslocoModule,
    MatIconModule,
    MainTaskSkeletonModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [
    MainTaskComponent,
    MainTasksComponent
  ],
})
export class MainTasksModule { }
